import moment from 'moment';
import userService from 'services/userData';
import authService from 'services/auth';

const localStorageKey = 'reportPersistence';
const dateFormat = 'yyyyMMDD';

export const reportTypes = {
    bidding: 'biddingReport'
};

const biddingReportsDefaults = {
    sortingMethod: ['revenue', 'name']
};

const getSortingMethod = (selectedSortingMethod, reportType, defaultType) => {
    const defaultSorting = {
        biddingReport: 'revenue'
    };
    const selectedSortingMethodSupported = defaultType.sortingMethod.indexOf(selectedSortingMethod) !== -1;

    return selectedSortingMethodSupported ? selectedSortingMethod : defaultSorting[reportType];
};

const saveReportData = (key, data) => localStorage.setItem(key, JSON.stringify(data));

const getDefaultsForLocalStorageData = async (paramsFromLocalStorage, reportType, itemInLocalStorage) => {
    const selectedBreakBy = paramsFromLocalStorage.breakBy;
    const selectedAdUnit = paramsFromLocalStorage.adUnit;
    const selectedSortingMethod = paramsFromLocalStorage.sortingMethod;
    const updatedParams = { ...paramsFromLocalStorage };

    if (reportType === reportTypes.bidding) {
        const selectedBreak = selectedBreakBy.split(',');
        let selectedBreakValue;
        const weekBreakIndex = selectedBreak.indexOf('week');
        const monthBreakIndex = selectedBreak.indexOf('month');

        // if week or month break
        if (weekBreakIndex !== -1) {
            selectedBreakValue = selectedBreak[weekBreakIndex];
        } else if (monthBreakIndex !== -1) {
            selectedBreakValue = selectedBreak[monthBreakIndex];
        }

        // if NOT date break (meaning week/month)
        if (selectedBreakValue) {
            updatedParams.breakBy = paramsFromLocalStorage.breakBy.replace(selectedBreakValue, 'date');
        }

        updatedParams.sortingMethod = getSortingMethod(selectedSortingMethod, reportType, biddingReportsDefaults);
    }

    const userData = await userService.getUserData();

    if (!userData.hasABTests) {
        updatedParams.testGroup = 'any';
    }

    // Update the local storage with default value
    saveReportData(itemInLocalStorage, updatedParams);

    return updatedParams;
};

const getDateKey = () => moment().format(dateFormat);

const getReportDataFromLocalStorage = async (itemInLocalStorage, reportType) => {
    const reportData = localStorage.getItem(itemInLocalStorage);

    if (!reportData) return null;

    const paramsFromLocalStorage = JSON.parse(reportData);
    const filteredParams = await getDefaultsForLocalStorageData(paramsFromLocalStorage, reportType, itemInLocalStorage);

    const todayKey = getDateKey();

    // if key is report persistence key not from today and is not the one in use, clean it
    Object.keys(localStorage)
        .filter((key) => {
            const notCurrentKey = key !== itemInLocalStorage;
            const isReportsKey = key.startsWith(localStorageKey);
            const notReportsKeyFromToday = !key.startsWith(localStorageKey + todayKey);

            return notCurrentKey && isReportsKey && notReportsKeyFromToday;
        })
        .forEach((key) => localStorage.removeItem(key));

    return filteredParams;
};

const getKey = async (companyId) => {
    let id = '';
    // if admin user and in mediation dashboard, use the company we're looking at
    if (await authService.isAuthorized(['admin']) && companyId) {
        id = `c${companyId}`;
    } else { // use logged user
        const userData = await userService.getUserData();
        id = userData.userId;
    }

    return localStorageKey + getDateKey() + id;
};

export default {
    getReportDataFromLocalStorage,
    getKey,
    saveReportData
};
